var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-danger small"},[_vm._v(" "+_vm._s(_vm.message || _vm.$t('error.error'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }